import React, { useEffect, Fragment, useState, memo } from 'react'
import Container from 'react-bootstrap/Container'
import Card from 'react-bootstrap/Card'
import { useDispatch, useSelector } from 'react-redux';
import { obtenerDatosLlaves } from "../../store/actions/caso-general-action";
import DatosGenerales from '../DatosGenerales';
import TabsComponent from './tabs';
import ImplicadoTerceros from '../implicadoTerceros';

import 'recupero-comunes/dist/index.css'



const CasoGeneral = memo(({idCaso,idImplicado, idOrganizacionCaso, detalles, setDatosCaso }) => {

  const dispatch = useDispatch();
  
  useEffect(() => {   
    dispatch(obtenerDatosLlaves({"idCaso":idCaso,"idImplicado":idImplicado,"idOrgCaso":idOrganizacionCaso}));
    //dispatch(obtenerDatosLlaves({"idCaso":27,"idImplicado":1,"idOrgCaso":99061000}))
     
    
  
  }, [dispatch])
  

  return (
    <>
    

      {/* {detalles ?<HitosCaso/>: <DatosGenerales/>} */}
      <DatosGenerales setDatosCaso = {setDatosCaso}/>
        <TabsComponent />
        <ImplicadoTerceros/>
      {/* {detalles ?<ImplicadoTercerosDetalles/>: <ImplicadoTerceros/>} */}
        
       
    </>
  )
})
export default CasoGeneral
